import { EColors, EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    title: string;
    onClick: () => void;
    className?: string;
}

export const MinuteActionWord = (props: Props): JSX.Element => {
    return (
        <S_MinuteActionWord className={props.className} onClick={props.onClick}>
            {props.title}
        </S_MinuteActionWord>
    );
};

const S_MinuteActionWord = styled.span`
    font-size: 13px;
    color: ${EColors.DARK};
    cursor: pointer;
    font-family: ${EFonts.Regular};
    text-decoration: underline;
    user-select: none;
    &:hover {
        text-decoration: none;
    }
`;
